import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-[#050505] flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="font-serif-display text-3xl block mb-16 text-center"
        >
          Wedding<span className="text-[#E11D2A]">·</span>Touch
        </Link>
        <div className="overline text-center mb-4">Studio access</div>
        <h1 className="font-serif-display text-4xl text-center mb-12">Sign in</h1>
        <form onSubmit={onSubmit} className="space-y-8">
          <div>
            <label className="overline block mb-2">Email</label>
            <input
              required
              type="email"
              data-testid="admin-login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="line-input w-full py-3"
            />
          </div>
          <div>
            <label className="overline block mb-2">Password</label>
            <input
              required
              type="password"
              data-testid="admin-login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="line-input w-full py-3"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-white text-black py-4 text-sm uppercase tracking-[0.2em] hover:bg-neutral-200 transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Enter studio"}
          </button>
        </form>
       <p></p>
      </div>
    </div>
  );
}
